import * as React from 'react';
import { TextBody, TextHeading, useModal, Space, Button, Modal, } from '@ally/metronome-ui';
import { CallUsBlock, bankNumbers, investNumbers, } from '../../../Components/CallUsBlock';
var headingRef = React.createRef();
// TODO: This is used only when in the DAO portal, but needs Home Loans contact info
export var CallUs = function (_a) {
    var focusOnMount = _a.focusOnMount;
    return (React.createElement(React.Fragment, null,
        React.createElement(TextBody, { size: "sm", tag: "p", focusOnMount: focusOnMount }, "Call us 24/7 for help."),
        React.createElement(TextBody, { size: "sm", tag: "p" },
            React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" }, "Bank"),
            ' ',
            bankNumbers.insideUS),
        React.createElement(TextBody, { size: "sm", tag: "p" },
            React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" }, "Invest"),
            ' ',
            investNumbers.insideUSPhone)));
};
export var ModalContent = function (_a) {
    var hasSingleDisplayOption = _a.hasSingleDisplayOption, isWebWrapped = _a.isWebWrapped, variation = _a.variation;
    var cantAccessOptionsCopy = hasSingleDisplayOption
        ? "Can't access this option?"
        : "Can't access these options?";
    return (React.createElement(React.Fragment, null,
        React.createElement(Space, { mb: "md" },
            React.createElement(TextHeading, { tag: "h1", size: "lg", tabIndex: -1, ref: headingRef }, cantAccessOptionsCopy)),
        React.createElement(CallUsBlock, { isWebWrapped: isWebWrapped, variation: variation })));
};
export var ModalTriggerComponent = function () {
    var showModal = useModal().showModal;
    return React.createElement(Button, { variant: "link", text: "give us a call", onClick: showModal });
};
export var InaccessibleModal = function (_a) {
    var hasSingleDisplayOption = _a.hasSingleDisplayOption, isWebWrapped = _a.isWebWrapped, variation = _a.variation;
    return (React.createElement(Modal, { content: React.createElement(ModalContent, { hasSingleDisplayOption: hasSingleDisplayOption, isWebWrapped: isWebWrapped, variation: variation }), ref: headingRef, trigger: React.createElement(ModalTriggerComponent, null), width: "md" }));
};
//# sourceMappingURL=InaccessibleModal.js.map